module.exports = "<p-accordion>\n  <p-accordionTab header=\"{{surveyInstance.title}}\" *ngFor=\"let surveyInstance of surveyInstances\">\n    <survey-details [surveyDetails]=\"surveyInstance\" [entityId]=\"entityIdDetails.entityId\" [isSurveyTab]=\"true\"></survey-details>\n  </p-accordionTab>\n</p-accordion>"


//////////////////
// WEBPACK FOOTER
// ./src/app/entities/surveys/surveylist/survey-list.component.html
// module id = 2269
// module chunks = 0